























import {
  Vue, Component, Mixins, Prop,
} from 'vue-property-decorator';
import MyForm from '@/mixins/form';

@Component
export default class extends Mixins(MyForm) {

  data:any={}

  mounted(opt:any){
    console.log('opt:',opt)
  }

  async loadData1(id:any) {
    this.spinLoading = true;
    this.loading = true;

    const res = await this.$store.dispatch("investigate/index", {
      id: id
    });

    if (res && res.Data) {
      let items=[]
      if(res.Data.items){
        let i=0;
        res.Data.items.forEach((item:any)=>{
          if(item.items){
            item.items.forEach((m:any)=>{
              i+=1
              m.sn=i
            })
          }
        })
      }
      this.data = res.Data;
    }

    this.loading = false;
    this.spinLoading = false;
  }

  getSn(n:any):any {
    if(n==0){
      return "A."
    }
    if(n==1){
      return "B."
    }
    if(n==2){
      return "C."
    }
    if(n==3){
      return "D."
    }
    return ""
  }
}
